import { ILocation } from 'src/app/interfaces/location';
import { BehaviorSubject, Subscription as RxSubscription } from 'rxjs';

import { LocationApiService } from './location-api-service';
import { PageEvent } from '@angular/material/paginator';
import { ApiDataSource } from 'src/app/services/api-data-source.service';
import { IResponseBody } from 'src/app/interfaces/response-body';

export class LocationDataSource extends ApiDataSource {
  protected Data: BehaviorSubject<ILocation[]> = new BehaviorSubject([]);

  constructor(
    protected Api: LocationApiService,
    private readonly role: any,
    private readonly endpointUrl: any,
    private readonly organisation: any
  ) {
    super();
  }

  public save(locationId: number, Location: ILocation) {
    return this.Api.save(
      this.role,
      this.organisation.id,
      locationId,
      Location
    ).then((result) => {
      this.loadWithPageEvent();
      return result.data;
    });
  }

  protected loadData(PageEvent?: PageEvent) {
    return this.Api.listWithPageEvent(
      this.role,
      this.endpointUrl,
      this.filter.value,
      this.organisation.id,
      PageEvent
    );
  }

  protected setData(ResponseBody: IResponseBody) {
    this.Data.next(ResponseBody.data);
  }
}
